import { SelectOption, SelectOptionWithDarkMode } from '../types/DropDownTypes'
import { GracePeriod } from '../types/MemberTypes'
import { RoleType } from '../types/UserTypes'

export const INVITATION = 'invitation'
export const NOT_ACTIVATED = 'not_activated'

export const severityOptions: SelectOptionWithDarkMode[] = [
  {
    value: 'critical',
    label: 'Detection',
    color: {
      light: '#bb0007',
      dark: '#FF6B6B', // soft red
    },
    bgColor: {
      light: '#ffefef',
      dark: '#4B1C1E', // dark red background
    },
  },
  {
    value: 'secure',
    label: 'Clear',
    color: {
      light: '#25784b',
      dark: '#7FFFD4', // mint green / aqua
    },
    bgColor: {
      light: '#eef9ee',
      dark: '#1E3D2A', // deep green
    },
  },
]

export const actionOptions: SelectOption[] = [
  { value: INVITATION, label: 'Send Invite' },
  { value: NOT_ACTIVATED, label: 'Remove Device' },
]

export const alertStatusOptions: SelectOptionWithDarkMode[] = [
  {
    value: 'open',
    label: 'Open',
    color: {
      light: '#4343c4',
      dark: '#AAB4FF',
    },
    bgColor: {
      light: '#f2f2ff',
      dark: '#2C2C55',
    },
  },
  {
    value: 'closed',
    label: 'Closed',
    color: {
      light: '#c73835',
      dark: '#FF8A80',
    },
    bgColor: {
      light: '#ffefef',
      dark: '#3B1F1F',
    },
  },
]

export const alertTypeOptions: SelectOptionWithDarkMode[] = [
  {
    value: 'device_scan',
    label: 'Device',
    color: { light: '#00749e', dark: '#68acc4' },
    bgColor: { light: '#E1F7FD', dark: '#1d3e56' },
  },
  {
    value: 'travel',
    label: 'Travel',
    color: { light: '#953ea3', dark: '#c878d5' },
    bgColor: { light: '#FBEAFB', dark: '#4d2953' },
  },
]

export const activatedOptions: SelectOptionWithDarkMode[] = [
  {
    value: 'yes',
    label: 'Yes',
    color: { light: '#25784b', dark: '#7FFFD4' },
    bgColor: { light: '#eef9ee', dark: '#1E3D2A' },
  },
  {
    value: 'no',
    label: 'No',
    color: { light: '#bb0007', dark: '#FF6B6B' },
    bgColor: { light: '#ffefef', dark: '#4B1C1E' },
  },
]

export const travelRiskOptions: SelectOptionWithDarkMode[] = [
  {
    value: 'HIGH',
    label: 'High',
    color: {
      light: '#bb0007',
      dark: '#FF6B6B',
    },
    bgColor: { light: '#ffefef', dark: '#4B1C1E' },
  },
  {
    value: 'MEDIUM',
    label: 'Medium',
    color: { light: '#d14e00', dark: '#d14e00' },
    bgColor: { light: '#fff3d8', dark: '#4A3A1A' },
  },
  {
    value: 'LOW',
    label: 'Low',
    color: { light: '#25784b', dark: '#7FFFD4' },
    bgColor: { light: '#eef9ee', dark: '#1E3D2A' },
  },
]

export const travelGuideOptions: SelectOptionWithDarkMode[] = [
  {
    value: 'ACKNOWLEDGED',
    label: 'Acknowledged',
    color: { light: '#25784b', dark: '#7FFFD4' },
    bgColor: { light: '#eef9ee', dark: '#1E3D2A' },
  },
  {
    value: 'NOT_ACKNOWLEDGED',
    label: 'Not Acknowledged',
    color: { light: '#d14e00', dark: '#d14e00' },
    bgColor: { light: '#fff3d8', dark: '#4A3A1A' },
  },
  {
    value: 'NOT_REQUIRED',
    label: 'Not Required',
    color: { light: '#0000009b', dark: '#a2a2a2' },
    bgColor: { light: '#00000010', dark: '#4b4949' },
  },
  {
    value: 'REQUIRED',
    label: 'Required',
    color: { light: '#bb0007', dark: '#FF6B6B' },
    bgColor: { light: '#ffefef', dark: '#4B1C1E' },
  },
]

export const rolesOptions: SelectOptionWithDarkMode[] = [
  {
    value: 'SUPER_ADMIN',
    label: RoleType.SUPER_ADMIN,
    description: 'Full access to all features and functions',
    color: {
      light: ' #5F3CC4',
      dark: ' #B197FC',
    },
    bgColor: {
      light: ' #F9F8FF',
      dark: ' #2E1A47',
    },
    order: 0,
  },
  {
    value: 'PLATFORM_MGMT',
    label: RoleType.PLATFORM_MGMT,
    description: 'Access platform settings only',
    color: {
      light: ' #1c2024',
      dark: ' #ffffff',
    },
    bgColor: {
      light: '#F9F8FF',
      dark: '#2E1A47',
    },
    order: 1,
  },
  {
    value: 'ACCESS_MGMT',
    label: RoleType.ACCESS_MGMT,
    description: 'Reinstate users suspended by conditional access',
    color: {
      light: '#1c2024',
      dark: '#ffffff',
    },
    bgColor: {
      light: '#F9F8FF',
      dark: '#2E1A47',
    },
    order: 2,
  },
  {
    value: 'GENERAL_ADMIN',
    label: RoleType.GENERAL_ADMIN,
    description: 'Add users, devices and alerts',
    color: {
      light: '#1c2024',
      dark: '#ffffff',
    },
    bgColor: {
      light: '#F9F8FF',
      dark: '#2E1A47',
    },
    order: 3,
  },
]

export const enrollOptions = [
  { value: 'ONCE', label: 'Once' },
  { value: 'WEEKLY', label: 'Weekly' },
  { value: 'EVERY_SECOND_DAY', label: 'Every Second Day' },
  { value: 'NEVER', label: 'Never' },
]
export const booleanOptions = [
  { value: 'ENABLED', label: 'Enabled' },
  { value: 'DISABLED', label: 'Disabled' },
]
export const outdatedOptions = [
  { value: 'DAILY', label: 'Daily' },
  { value: 'EVERY_SECOND_DAY', label: 'Every Second Day' },
  { value: 'WEEKLY', label: 'Weekly' },
  { value: 'NEVER', label: 'Never' },
]
export const scanOptions = [
  { value: 'THREE_DAYS', label: '3 Days' },
  { value: 'SEVEN_DAYS', label: '7 Days' },
  { value: 'TWO_WEEKS', label: '2 Weeks' },
  { value: 'NEVER', label: 'Never' },
]
export const pushOptions = [
  { value: 'DAILY', label: 'Daily' },
  { value: 'EVERY_SECOND_DAY', label: 'Every Second Day' },
  { value: 'WEEKLY', label: 'Weekly' },
]
export const deliveryOptions = [
  { value: 'PUSH', label: 'Push' },
  { value: 'EMAIL', label: 'Email' },
]

export const gracePeriodOptions: SelectOption[] = [
  { value: GracePeriod.ONE_HOUR, label: '1 Hour' },
  { value: GracePeriod.FOUR_HOURS, label: '4 Hours' },
  { value: GracePeriod.ONE_DAY, label: '1 Day' },
  { value: GracePeriod.THREE_DAYS, label: '3 Days' },
  { value: GracePeriod.ONE_WEEK, label: '1 Week' },
]
